import script from "./ManagingDirrector2.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagingDirrector2.vue?vue&type=script&setup=true&lang=js"

import "./ManagingDirrector2.vue?vue&type=style&index=0&id=4c663008&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c663008"]])

export default __exports__